import React, { useState } from 'react'
import style from './cardListProjects.module.scss'
import { useAppSelector } from '../../starter/hooks/redux'
import { useDrop } from 'react-dnd'
import { IProject } from '../../starter/model/interfaces'
import CardProjectSmall from '../CardProjectSmall/CardProjectSmall'
import { DeleteOutlined } from '@ant-design/icons'
import { useUpdateSequenceProjectMutation } from '../../starter/api/sequenceProjectApi'
import { Input } from 'antd'

const CardListProjects = () => {
  const { projects } = useAppSelector((state) => state.projects)
  const [UpdateSequence] = useUpdateSequenceProjectMutation()
  const { sequenceProject: sortedProjectTemplate } = useAppSelector((state) => state.sequenceProject)
  const [filter, setFilter] = useState<string>('')

  const [{ isActive, canDrop }, dropRef] = useDrop({
    accept: 'project',
    drop(item: IProject) {
      const _sortedProjectTemplate = [...sortedProjectTemplate]
      UpdateSequence(_sortedProjectTemplate.filter((f) => f !== item._id))
    },
    collect: (monitor) => ({
      isActive: monitor.isOver(),
      canDrop: monitor.canDrop()
    })
  })
  const filterPattern = (item: IProject) => {
    return item.title.toLowerCase().includes(filter.toLowerCase())
  }

  return (
    <div className={style.wrapper} ref={dropRef}>
      {(isActive || canDrop) && (
        <div className={style.remove}>
          <DeleteOutlined className={style.removeIcon} />
        </div>
      )}
      <Input
        value={filter}
        onChange={(e) => {
          setFilter(e.target.value)
        }}
      />
      <div className={style.list}>
        {projects &&
          projects.filter(filterPattern).map((project) => <CardProjectSmall key={project._id} project={project} />)}
      </div>
    </div>
  )
}
export default CardListProjects
